// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ULSr","image":"Header_image__26HJc","name":"Header_name__2yuxq","info":"Header_info__1MZJV","infoRow":"Header_infoRow__1yzB0"};